import React from 'react'
import { Button, Dialog } from 'modules/ui'

export default function StartOver({
  theme,
  handleToggleStartOver,
  handleStartOver,
  showConfirmStartOver
}) {
  const actions = [
    { label: 'Cancel ', onClick: handleToggleStartOver },
    {
      label: 'Start Over',
      onClick: handleStartOver,
      primary: true,
      raised: true
    }
  ]

  return (
    <div>
      <Button
        onClick={handleToggleStartOver}
        title="Start Over"
        theme={theme}
        floating
        primary
        icon="settings_backup_restore"
      />
      <Dialog
        active={showConfirmStartOver}
        onEscKeyDown={handleToggleStartOver}
        onOverlayClick={handleToggleStartOver}
        actions={actions}
        title="Start Over !?"
      >
        <p>Starting over will cause you to lose any unfinshed progress.</p>
      </Dialog>
    </div>
  )
}



// WEBPACK FOOTER //
// ./client/modules/user/components/StartOver/StartOver.js